/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IProductSpotlightViewProps } from './product-spotlight';

export default (props: IProductSpotlightViewProps) => {
    return <>{props.ProductSpotlight}</>;
};
